import { Divider, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import {
  getVendorWithSuperCategory,
  getAllSuperCategory,
  getAllCategory,
  getAllRestaurantType,
  pushEvent
} from '../../../store/actions/user/User';
import { saveEventData } from "../../../utils/events-handler"
import GridItem from '../../Grid/GridItem';
import VendorCard from './VendorCard';
import NoData from '../NoData/NoData';
import LiquorCard from './LiquorCard';
import LeftTab from '../ProductAndMenus/LeftTab'
import Hidden from '@material-ui/core/Hidden';
import { Paper, Button } from '@material-ui/core'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Footer from '../../Footer/Footer';
import ReactPixel from 'react-facebook-pixel';


const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};
const useStyles = makeStyles((theme) => ({
  vendorContainer: {
    maxWidth: '1024px',
    margin: '4rem auto',
    [theme.breakpoints.down('sm')]: {
      padding: '6rem 2rem'
    }
  },
  superCategoryDetail: {
    display: 'flex'
  },
  superCategoryImage: {
    paddingTop: '0rem',
    fontSize: '24px',
    fontWeight: 'bold'
  },
  vendorListing: {
    marginTop: '1rem',
    textTransform: 'capitalize'
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    marginTop: '6px',
    width: '100%',
    textTransform: 'capitalize'
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    textTransform: 'capitalize'
  },
  superCategoryName: {
    paddingTop: '7%',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '32%'
    }
  }
}));

function Item(props) {
  const superCategory = props.superCategory
  return (
    <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
      <img src={props.src} style={{ borderRadius: '20px' }} />
    </div>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box width="100%">{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

const SuperCategory = (props) => {
  const [isRestaurant, updateIsRestaurant] = useState(false);
  const [isLoading, updateIsLoading] = useState(false);
  const [superCategory, updateSuperCategory] = useState({});
  const [todayDay, setTodayDay] = useState('sunday');
  const [vendorBySuperCategory, updateVendorBySuperCategory] = useState([]);
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 20;
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue, mobile) => {
    setValue(newValue);
    if (mobile)
      handleDrawerToggle()
  };

  const whichDayIsToday = () => {
    let d = new Date();
    let weekday = new Array(7);
    weekday[0] = 'sunday';
    weekday[1] = 'monday';
    weekday[2] = 'tuesday';
    weekday[3] = 'wednesday';
    weekday[4] = 'thursday';
    weekday[5] = 'friday';
    weekday[6] = 'saturday';
    setTodayDay(weekday[d.getDay()]);
  };

  useEffect(() => {
    const { superCategoryId } = props.match.params;
    updateIsLoading(true);
    const payload = {
      superCategoryId: superCategoryId,
      latitude: localStorage.getItem('latitude') || '-33.865143',
      longitude: localStorage.getItem('longitude') || '151.209900'
    };
    props.getAllSuperCategory();
    props.getAllCategory(superCategoryId);
    whichDayIsToday();
    props.getAllRestaurantType(superCategoryId);
    props
      .getVendorWithSuperCategory(payload)
      .then((resp) => {
        updateVendorBySuperCategory(resp?.data);
        updateIsLoading(false);
      })
      .catch((err) => { });

  }, []);

  useEffect(() => {
    if (props?.superCategories) {
      const { superCategoryId } = props.match.params;
      const superCategory = props?.superCategories?.find((item) => {
        return item.id === superCategoryId;
      });
      updateIsRestaurant(superCategory?.isResturant);
      updateSuperCategory(superCategory);
      let eventsApiCall;
      if (superCategory?.eventTag) {
        const options = {
          autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
          debug: false, // enable logs
        };
        ReactPixel.init('831925394401262', {}, options);
        ReactPixel.trackCustom(superCategory?.eventTag, { 'url': window.location.href });
        saveEventData(props.pushEvent, superCategory?.eventTag)
        eventsApiCall = setInterval(() => {
          saveEventData(props.pushEvent, superCategory?.eventTag)
        }, 120000)
      } else {
        saveEventData(props.pushEvent, "SuperCategoryView")
        eventsApiCall = setInterval(() => {
          saveEventData(props.pushEvent, "SuperCategoryView")
        }, 120000)

      }
      return () => {
        clearInterval(eventsApiCall);
      };
    }
  }, [props?.superCategories]);

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const restaurantType = props.restaurantType;
  return (
    <div style={{ background: 'white', paddingTop:'10px' }}>
      <div className="container" style={isRestaurant ? { maxWidth: '91%' } : {}}>
        <div className="mr-0 pl-0">
          <div className={classes.superCategoryName}>
            {/* <div
              className="col-lg-1 col-md-3 col-sm-4 col-5"
              style={{ textAlign: 'left', marginLeft: '2.5%', padding: '0px' }}
            ></div> */}
            <div style={{ textAlign: 'left' }}>
              <h2
                style={{ color: 'black', fontWeight: 'bold', fontSize: '1.6em' }}
                className="bgImage4Title"
              >
                {superCategory?.name}
              </h2>
              <h4 style={{ color: 'grey', fontSize: '1em' }}>
                {localStorage.getItem('city')}
              </h4>
            </div>
          </div>
        </div>
        <hr></hr>
        {superCategory?.coverImages &&

          <Carousel responsive={responsive}>
            {
              superCategory?.coverImages.map((item, i) => <Item key={i} src={item} superCategory={superCategory} />)
            }
          </Carousel>
        }
        <hr></hr>
      </div>
      <div className={isRestaurant ? "container-fluid" : "container"}>
        <div className="mr-0 pl-0">
          <div className={classes.superCategoryDetail}>
            <b
              className={classes.superCategoryImage}
              style={isRestaurant ? { paddingLeft: '5%', fontWeight: 700 } : { fontWeight: 700 }}
            >
              {props.vendorLoading ? 'Loading Outlets please wait...' : `${vendorBySuperCategory?.length} Outlets near you`}
            </b>
          </div>
        </div>
        {!isLoading ? (
          <div className={classes.root} style={{ background: 'white' }}>
            {isRestaurant && (
              <>
                <div style={{ width: '5%' }}>
                  <Hidden lgUp implementation="css" >
                    <LeftTab mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} handleChange={(event, newValue) => handleChange(event, newValue, true)} value={value} categories={[{ name: 'All' }].concat(restaurantType)} a11yProps={a11yProps} />
                  </Hidden>
                </div>
                <Hidden mdDown implementation="css">
                  <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    className={classes.tabs}
                    style={{
                      width: '100%',
                      marginLeft: '5px',
                      textTransform: 'capitalize'
                    }}
                  >
                    <Tab
                      label="All "
                      style={{ textTransform: 'capitalize' }}
                      {...a11yProps(0)}
                    />
                    {restaurantType.length !== 0
                      ? restaurantType.map((item, index) => (
                        <Tab
                          label={item.name}
                          style={{ textTransform: 'capitalize' }}
                          {...a11yProps(index + 1)}
                        />
                      ))
                      : ''}
                  </Tabs>
                </Hidden>
              </>
            )}
            <TabPanel value={value} index={0} style={{ width: '100%' }}>
              <div className="container">
                <div className="container-fluid">
                  <div className="row">
                    {vendorBySuperCategory?.length ? (
                      vendorBySuperCategory?.map(
                        (vendor) => (
                          // !isRestaurant ? (
                          <GridItem xs={12} sm={12} md={4}>
                            {isRestaurant ? (
                              <VendorCard
                                icon={vendor?.logo}
                                name={vendor?.name}
                                longitude1={vendor.address.longitude}
                                latitude1={vendor.address.latitude}
                                street={vendor?.address?.street}
                                city={vendor?.address?.city}
                                superCategoryId="1f0fc530-3e38-11eb-9bf7-736099e10ae1"
                                restaurantType2={props.restaurantType}
                                restaurantType3={vendor?.restaurantType}
                                days={vendor?.address?.days}
                                closetime={vendor?.timing[todayDay]?.closeTime}
                                opentime={vendor?.timing[todayDay]?.openTime}
                                id={vendor.id}
                                duration={vendor?.distanceAndDuration?.duration}
                                distance={vendor?.distance}
                                shopOpen={vendor.shopOpen}
                              />
                            ) : (
                                <LiquorCard
                                  shopOpen={vendor.shopOpen}
                                  icon={vendor?.logo}
                                  name={vendor?.name}
                                  street={vendor?.address?.street}
                                  city={vendor?.address?.city}
                                  days={vendor?.address?.days}
                                  longitude1={vendor?.address?.longitude}
                                  latitude1={vendor?.address?.latitude}
                                  closetime={vendor?.timing[todayDay]?.closeTime}
                                  opentime={vendor?.timing[todayDay]?.openTime}
                                  id={vendor.id}
                                  duration={vendor?.distanceAndDuration?.duration}
                                  distance={vendor?.distance}
                                />
                              )}
                          </GridItem>
                        )
                        // ) : null
                      )
                    ) : (
                        <NoData />
                      )}
                  </div>
                </div>
              </div>
            </TabPanel>
            {props.restaurantType
              ? restaurantType.map((item, index) => (
                <TabPanel
                  value={value}
                  index={index + 1}
                  style={{ width: '100%' }}
                >
                  <div className="container-fluid">
                    <div
                      style={{ textAlign: 'left' }}
                      className={classes.superCategoryImage}
                    >
                      {item.name}
                    </div>
                    <div className="row">
                      {props?.vendorBySuperCategory?.length ? (
                        props?.vendorBySuperCategory
                          ?.filter(
                            (categorieFilter) =>
                              categorieFilter.restaurantType && Array.isArray(categorieFilter.restaurantType) && categorieFilter.restaurantType[0] === item.id
                          )
                          .map((vendor) =>
                            vendor.restaurantType.indexOf(item.name) >= 0 ? (
                              <GridItem xs={12} sm={12} md={4}>
                                <VendorCard
                                  icon={vendor?.logo}
                                  longitude1={vendor.address.longitude}
                                  latitude1={vendor.address.latitude}
                                  street={vendor?.address?.street}
                                  city={vendor?.address?.city}
                                  superCategoryId="1f0fc530-3e38-11eb-9bf7-736099e10ae1"
                                  days={vendor?.address?.days}
                                  restaurantType2={props.restaurantType}
                                  restaurantType3={vendor?.restaurantType}
                                  closetime={
                                    vendor?.timing[todayDay]?.closeTime
                                  }
                                  opentime={
                                    vendor?.timing[todayDay]?.openTime
                                  }
                                  shopOpen={vendor.shopOpen}
                                  id={vendor.id}
                                  distance={vendor?.distance}
                                />
                              </GridItem>
                            ) : (
                                <GridItem xs={12} sm={12} md={4}>
                                  <VendorCard
                                    icon={vendor?.logo}
                                    name={vendor?.name}
                                    longitude1={vendor.address.longitude}
                                    latitude1={vendor.address.latitude}
                                    street={vendor?.address?.street}
                                    city={vendor?.address?.city}
                                    superCategoryId="1f0fc530-3e38-11eb-9bf7-736099e10ae1"
                                    restaurantType2={props.restaurantType}
                                    restaurantType3={vendor?.restaurantType}
                                    days={vendor?.address?.days}
                                    closetime={
                                      vendor?.timing[todayDay]?.closeTime
                                    }
                                    opentime={
                                      vendor?.timing[todayDay]?.openTime
                                    }
                                    shopOpen={vendor.shopOpen}
                                    id={vendor.id}
                                    distance={vendor?.distance}
                                  />
                                </GridItem>
                              )
                          )
                      ) : (
                          <NoData />
                        )}
                    </div>
                  </div>
                </TabPanel>
              ))
              : ''}
          </div>
        ) : null}
      </div>
      <br />
      <br />
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  vendorBySuperCategory: state.user.vendorBySuperCategory,
  superCategories: state.user.superCategories,
  categories: state.user.categories,
  restaurantType: state.user.restaurantType,
  vendorLoading: state.user.vendorLoading
});

const mapDispatchToProps = (dispatch) => ({
  getAllSuperCategory: () => dispatch(getAllSuperCategory()),
  getVendorWithSuperCategory: (superCategory) =>
    dispatch(getVendorWithSuperCategory(superCategory)),
  getAllCategory: (superCategory) => dispatch(getAllCategory(superCategory)),
  getAllRestaurantType: (superCategory) =>
    dispatch(getAllRestaurantType(superCategory)),
  pushEvent: (details) => dispatch(pushEvent(details))
});

export default connect(mapStateToProps, mapDispatchToProps)(SuperCategory);
